export const apiService = {
  postRequest: async <T>(
    url: string,
    requestBody: Record<string, unknown>,
    apiKey: string,
  ): Promise<T> => {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-functions-key': apiKey,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        let errorMessage = `HTTP error! status: ${response.status}`;
        try {
          const errorBody = await response.json();
          if (errorBody.message) {
            errorMessage += `, message: ${errorBody.message}`;
          }
        } catch (jsonError) {
          console.error('Failed to parse error response JSON:', jsonError);
        }
        throw new Error(errorMessage);
      }

      const data: T = await response.json();
      return data;
    } catch (error) {
      console.error('Error during POST request:', error);
      throw error;
    }
  },

  getRequest: async <T>(
    url: string,
    queryParams: Record<string, unknown>,
    apiKey: string,
  ): Promise<T> => {
    try {
      const queryString = new URLSearchParams(
        queryParams as Record<string, string>,
      ).toString();
      const fullUrl = queryString ? `${url}?${queryString}` : url;

      const response = await fetch(fullUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-functions-key': apiKey,
        },
      });

      if (!response.ok) {
        let errorMessage = `HTTP error! status: ${response.status}`;
        try {
          const errorBody = await response.json();
          if (errorBody.message) {
            errorMessage += `, message: ${errorBody.message}`;
          }
        } catch (jsonError) {
          console.error('Failed to parse error response JSON:', jsonError);
        }
        throw new Error(errorMessage);
      }

      const data: T = await response.json();
      return data;
    } catch (error) {
      console.error('Error during GET request:', error);
      throw error;
    }
  },
};
